import { FIELD_BASE_CLASS, fieldBorderClass } from '@/components/base/shared-classes';

export interface TextareaProps {
  uiId: string;
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  invalid?: boolean;
  name?: string;
  /** 原系統該欄位的長度上限（maxlength）。沒給就不輸出這個屬性。 */
  maxLength?: number;
}

/** bootstrap.css:2589-2593（disabled 底色）＋ 2598-2600 `textarea.form-control { height:auto }`。 */
const DISABLED_BG_CLASS = 'disabled:bg-[#eee]';

/**
 * 多行文字輸入。
 *
 * ponytail: 不做自動增高、不做字數統計、不開 rows prop —— 高度用原生預設，
 * 真的需要特定高度時由呼叫端在外層容器控制。原系統的 textarea 也只是 `.form-control`。
 */
export function Textarea({
  uiId,
  value,
  onChange,
  placeholder,
  disabled = false,
  readOnly = false,
  invalid = false,
  name,
  maxLength,
}: TextareaProps) {
  return (
    <textarea
      data-ui-id={uiId}
      name={name}
      maxLength={maxLength}
      className={`${FIELD_BASE_CLASS} ${fieldBorderClass(invalid)} ${DISABLED_BG_CLASS} h-auto`}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      aria-invalid={invalid}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
